export default __webpack_public_path__ + "static/media/D01.dd73e736.png";